import MasterWriterApp from '@/src/masterWriterApp'
import MasterWriterPosts from '@/pages/masterWriter/Posts/index.vue'
import MasterWriterOrderBoard from '@/pages/masterWriter/OrderBoard/index.vue'
import MasterWriterWriterReports from '@/pages/masterWriter/WriterReports/index.vue'
import MasterWriterProfiles from '@/pages/masterWriter/Profiles/index.vue'
import MasterWriterUsersSidebar from '@/components/sidebars/masterWriter/UsersSidebar'
import MasterWriterSystemInformations from '@/pages/masterWriter/systemInformations/index'
import MasterWriterEmail from '@/pages/masterWriter/Emails/index.vue'

export default {
  path: '/master_writer',
  component: MasterWriterApp,
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      redirect: { name: 'masterWriterPosts' }
    },
    {
      path: 'posts',
      name: 'masterWriterPosts',
      component: MasterWriterPosts
    },
    {
      path: 'order_board',
      name: 'masterWriterOrderBoard',
      component: MasterWriterOrderBoard
    },
    {
      path: 'users',
      name: 'masterWriterUsers',
      redirect: 'users/writer_reports'
    },
    {
      path: 'users/writer_reports',
      name: 'masterWriterWriterReports',
      components: {
        default: MasterWriterWriterReports,
        subSidebar: MasterWriterUsersSidebar
      }
    },
    {
      path: 'profiles',
      name: 'masterWriterProfiles',
      components: {
        default: MasterWriterProfiles
      }
    },
    {
      path: 'system_informations',
      name: 'masterWriterSystemInformations',
      component: MasterWriterSystemInformations
    },
    {
      path: 'emails',
      name: 'masterWriterEmails',
      components: {
        default: MasterWriterEmail
      }
    }
  ]
}
